// Admin "view as user" — client-side session store (sessionStorage so it dies with the tab).
const KEY = 'lux_view_as';
const MSG_KEY = 'lux_view_as_msg';

export const CONTROL_PREFIX = '/admin/impersonation';
export const SESSION_HEADER = 'X-Impersonate-Session';
export const READONLY_MESSAGE = 'Read-only while viewing as another user';
export const ENDED_MESSAGE = 'Impersonation session ended';

export const ROLE_LABELS = { admin: 'Admin', surveyor: 'Surveyor', operative: 'Operative', sub_contractor: 'Sub-contractor', office: 'Office', employee: 'Operative' };
export const roleLabel = (s) => (s?.acting_user_type === 'sub_contractor' ? ROLE_LABELS.sub_contractor : ROLE_LABELS[s?.acting_role] || ROLE_LABELS[s?.acting_user_type] || s?.acting_role || '');

const KEEP = ['id', 'token', 'real_user_id', 'real_name', 'acting_as_user_id', 'acting_name', 'acting_role', 'acting_user_type', 'expires_at', 'allow_edits', 'extensions', 'return_to', 'started_at'];
export const slim = (s) => Object.fromEntries(KEEP.filter((k) => s?.[k] !== undefined).map((k) => [k, s[k]]));

export const readViewAs = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || 'null'); } catch { return null; } };
export const writeViewAs = (v) => { try { v ? sessionStorage.setItem(KEY, JSON.stringify(slim(v))) : sessionStorage.removeItem(KEY); } catch { /* noop */ } }; // eslint-disable-line no-empty
export const takeMessage = () => { try { const m = sessionStorage.getItem(MSG_KEY); sessionStorage.removeItem(MSG_KEY); return m; } catch { return null; } };

/** Drop the session locally and hard-navigate back to where the admin started (a full reload clears every cached view). */
export const finishViewAs = (message) => {
  const va = readViewAs();
  writeViewAs(null);
  try { if (message) sessionStorage.setItem(MSG_KEY, message); } catch { /* noop */ } // eslint-disable-line no-empty
  window.location.assign(va?.return_to || '/projects');
};

export const secondsLeft = (s) => (s?.expires_at ? Math.max(0, Math.floor((new Date(s.expires_at).getTime() - Date.now()) / 1000)) : 0);
